export const AUTH_REQUIRED_REASON = "account_required";
export const ACCOUNT_REGISTER_ICON_SRC = "/assets/events/register_user.svg";

export function buildAuthRequiredPath({ tab = "", next = "", ref = "" } = {}) {
  const params = new URLSearchParams();
  params.set("reason", AUTH_REQUIRED_REASON);

  if (tab) params.set("tab", tab);
  if (next) params.set("next", next);
  if (ref) params.set("ref", ref);

  return `/auth?${params.toString()}`;
}
